import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { CreateExportParams, ExportDialogTypeEnum, ToCreateExportParams } from '../export-dialog.types';

@Injectable({
  providedIn: 'root'
})
export class ExportDialogService {
  private readonly inputWhereNameMap = {
    [ExportDialogTypeEnum.users]: 'userWhere',
    [ExportDialogTypeEnum.groups]: 'groupWhere',
    [ExportDialogTypeEnum.locations]: 'locationWhere',
    [ExportDialogTypeEnum.equipments]: 'equipmentWhere',
    [ExportDialogTypeEnum.quotations]: 'quotationWhere',
    [ExportDialogTypeEnum.recurrences]: 'recurrenceWhere',
    [ExportDialogTypeEnum.maintenances]: 'maintenanceWhere',
    [ExportDialogTypeEnum.maintenancesImr]: 'maintenanceImrWhere',
    [ExportDialogTypeEnum.productsServices]: 'productServiceWhere',
    [ExportDialogTypeEnum.formAnswers]: 'dashboardFormsAnswersDetailWhere',
    [ExportDialogTypeEnum.productsServicesTopCompanies]: 'dashboardProductsServicesTopCompaniesWhere',
  };

  private readonly inputIncludesNameMap = {
    [ExportDialogTypeEnum.locations]: 'locationInclude',
  };

  constructor(private readonly apollo: Apollo) {}

  public async createExport(input: CreateExportParams): Promise<void> {
    await this.apollo
      .query<any>({
        query: gql`
          mutation createExport($input: CreateExportInput!) {
            createExport(input: $input) {
              id
            }
          }
        `,
        variables: {
          input
        }
      })
      .toPromise();
  }

  public toCreateExportParams({ type, where, include }: ToCreateExportParams): CreateExportParams {
    const params = {
      type,
      language: navigator.language || 'pt-BR',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      [this.inputWhereNameMap[type]]: where || null,
    };

    if (this.inputIncludesNameMap[type]) {
      params[this.inputIncludesNameMap[type]] = include || null;
    }

    return params;
  }
}
